import { isLocalhost, isProd } from "common/utils";

type SwConfig = {
  isUpdate: boolean;
};

export const register = (config: SwConfig) => {
  console.warn("service worker register.");
  if (isProd && "serviceWorker" in navigator) {
    const publicUrl = new URL(import.meta.env.BASE_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    const swUrl = `${window.location.origin}/service-worker.js`;
    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
      navigator.serviceWorker.ready.then(() => {
        console.warn(
          "This web app is being served cache-first by a service " +
            "worker. To learn more, visit https://cra.link/PWA",
        );
      });
    } else {
      registerValidSW(swUrl, config);
    }
  }
};

export const registerValidSW = (swUrl: string, config: SwConfig) => {
  navigator.serviceWorker
    .register(swUrl)
    .then(async (registration) => {
      console.warn("service worker registration. ");
      if (config && config.isUpdate) {
        await registration.update();

        setTimeout(() => {
          console.warn("service worker update timeout.");
          window.location.reload();
        }, 10000);

        registration.onupdatefound = () => {
          console.warn("service worker update.");
          const installingWorker = registration.installing;
          if (installingWorker == null) {
            return;
          }
          installingWorker.onstatechange = () => {
            if (installingWorker.state === "installed") {
              registration.waiting.postMessage({ type: "SKIP_WAITING" });
              window.location.reload();
            }
          };
        };
      }
    })
    .catch((error) => console.error(JSON.stringify(error)));
};

export const checkValidServiceWorker = (swUrl: string, config: SwConfig) => {
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
  })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.error("No internet connection found. App is running in offline mode.");
    });
};

export const unregister = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => console.error(JSON.stringify(error)));
  }
};
